/**
 * @generated SignedSource<<d5497e50f089d21a05e457c0686286fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type editorOnboardingStateKey$data = {
  readonly key: string;
  readonly value: string | null | undefined;
  readonly " $fragmentType": "editorOnboardingStateKey";
};
export type editorOnboardingStateKey$key = {
  readonly " $data"?: editorOnboardingStateKey$data;
  readonly " $fragmentSpreads": FragmentRefs<"editorOnboardingStateKey">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "editorOnboardingStateKey",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "type": "OnboardingState"
};

(node as any).hash = "5d1c26c59c43466acf7e648ca042a885";

export default node;
